import React from 'react';
import s1 from '../../assets/img/serviceoursmapbim/1.png';
import s2 from '../../assets/img/serviceoursmapbim/2.png';
import s3 from '../../assets/img/serviceoursmapbim/3.png';

const ServiceOurMapBim = () => {
  const mepServices = [
    { title: "MEP 3D Modeling", img: s1 },
    { title: "MEP Clash Detection", img: s2 },
    { title: "Construction Documentation", img: s3 },
    { title: "MEP Content Revit Family Creation", img: s1 },
    { title: "MEP Quantity take-off and BOM", img: s2 },
    { title: "MEP Fabrication Drawings", img: s3 }
  ];

  return (
    <section className="mep-modeling-services">
      <div className="modeling-container">
        <div className="modeling-header">
          <h2 className="modeling-title">
            Our <span className="text-primary">MEP BIM</span> Modeling Services
          </h2>
        </div>

        <div className="modeling-grid">
          {mepServices.map((service, index) => (
            <div key={index} className="modeling-card-wrapper">
              <div className="modeling-card">
                <div className="card-img-box">
                  <img src={service.img.src || service.img} alt={service.title} />
                </div>
                <div className="card-content">
                  <h3>{service.title}</h3>
                  <div className="title-underline"></div>
                </div>
              </div>
              <div className="card-shadow-bg"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOurMapBim;
